import { get } from "lodash";

export const filterObjectsBySearch = (
  searchValue: string | undefined,
  object: any,
  searchFields: string[][]
) => {
  if (!searchValue) {
    return true;
  }
  return searchFields.some((searchField) => {
    let fieldValue = get(object, searchField, "");
    if (typeof fieldValue === "number") {
      fieldValue = fieldValue.toString();
    } else if (typeof fieldValue !== "string") {
      return false;
    }
    return fieldValue
      ? fieldValue.toLowerCase().includes(searchValue.toLowerCase())
      : false;
  });
};

export function extractFloatString(string: any, numDigits: number) {
  if (!string) {
    return null;
  } else if (typeof string === "number") {
    return string;
  }
  const regex = new RegExp(
    `\\d+${numDigits ? `\[\.\,]?\\d{0,${numDigits}}` : ""}`
  );
  const match = string.match(regex);
  return match ? match[0]?.replace(",", ".") : null;
}
